import VueRouter from "vue-router";

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login')
  },
  {
    path: '/studio/preview',
    name: 'stduio.preview',
    component: () => import('../views/StudioPreview')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Logout')
  },
  {
    path: '/',
    name: 'layout',
    redirect: '/home',
    component: () => import('../components/layout/Index.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {title: "首页", requireAuth: true, menu: 'home', subMenu: '', permission: 'home'},
        component: () => import('../views/Home.vue')
      },
      {
        path: '/home/AiDashboard',
        name: 'home.AiDashboard',
        meta: {title: "机器人详情", requireAuth: false,},
        component: () => import('../views/AiDashboard.vue')
      },
      {
        path: '/home/historicVersion',
        name: 'home.historicVersion',
        meta: {title: "历史版本", requireAuth: false},
        component: () => import('../views/historicVersion.vue')
      },
      {
        path: 'case/zhuanbingInsight/:patientId',
        component: () => import('../views/Insight.vue'),
        name: 'case.zhuanbingInsight',
        props: true,
        meta: {description: '专病智能分析',requiresAuth: true,menu: 'case',subMenu: '',permission: 'case.zhuanbingInsight'}
      },
      {
        path: '/home/extraction',
        name: 'home.ai-disease-extraction',
        meta: {title: "机器人抽取病例", requireAuth: false},
        component: () => import('../views/AiExtractionCase.vue')
      },
      {
        path: '/home/result',
        name: 'home.aiResult',
        meta: {title: "机器人抽取病例", requireAuth: false},
        component: () => import('../views/AiResult.vue')
      },
      {
        path: '/case',
        redirect: 'case/general',
      },
      {
        path: '/case/configMgr',
        /*INFO:注意，如果改变name的值，请搜索case.config确保程序里面对应的地方也修改*/
        name: 'case.configMgr',
        meta: {title: '专病配置列表', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.config', permission: 'case.config'},
        component: () => import('../views/ZhuanbingConfigMgr')
      },
      {
        path: '/case/config',
        /*INFO:注意，如果改变name的值，请搜索case.config确保程序里面对应的地方也修改*/
        name: 'case.config',
        meta: {title: '专病配置', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.config', permission: 'case.config'},
        component: () => import('../views/ZhuanbingConfig')
      },
      {
        path: '/case/config/:zhuanbingId',
        name: 'case.config.edit',
        props: true,
        meta: {title: '专病配置编辑', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.config', permission: 'case.config'},
        component: () => import('../views/ZhuanbingConfig')
      },
      {
        path: '/case/collection/:patientId?/:step?',
        props: true,
        name: 'case.collection',
        meta: {title: '专病采集', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.collection', permission: 'case.collection'},
        component: () => import('../views/CaseCollection')
      },
      {
        path: '/case/zhuanbingNameList',
        props: true,
        name: 'case.zhuanbingNameList',
        meta: {title: '专病选择弹窗框', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.collection', permission: 'case.collection'},
        component: () => import('../views/zhuanbingNameList')
      },
      {
        path: '/case/aiMedcase',
        props: true,
        name: 'case.aiMedcase',
        meta: {title: 'AI电子病历', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.aiMedcase', permission: 'case.aiMedcase'},
        component: () => import('../views/CaseAi')
      },
      {
        path: '/case/EfficacyFeedback/:patientId',
        props: true,
        name: 'case.EfficacyFeedback',
        meta: {title: '疗效反馈', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.collection', permission: 'case.EfficacyFeedback'},
        component: () => import('../views/EfficacyFeedback')
      },
      {
        path: '/case/zhuanbingReinput/:reInputPatientId',
        name: 'case.zhuanbingReinput',
        props: true,
        meta: {title: '专科病历复诊', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.collection', permission: 'case.collection'},
        component:() => import('../views/CaseCollection')
      },
      {
        path: '/case/zhuanbingDiagnosis/:patientId',
        props: true,
        component: () => import('../views/zhuanbingDiagnosis'),
        name: 'case.zhuanbingDiagnosis',
        meta: {description: '专病病历诊断',requiresAuth: true,menu: 'case',subMenu: 'case.collection',permission: 'case.zhuanbingDiagnosis'}
      },
      {
        path: '/case/zhuanbingCalibration/:patientId',
        component: () => import('../views/zhuanbingCalibration'),
        name: 'case.zhuanbingCalibration',
        props:true,
        meta: {description: '专病病历审核',requiresAuth: true,menu: 'case',subMenu: 'case.collection',permission: 'case.zhuanbingCalibration'}
      },
      {
        path: 'case/zhuanbingDetails/:patientId',
        component: () => import('../views/zhuanbingMedicalResult.vue'),
        name: 'case.zhuanbingMedicalResult',
        props: true,
        meta: {description: '专病病历查看',requiresAuth: true,menu: 'case',subMenu: 'case.inquire',permission: 'case.zhuanbingMedicalResult'}
      },
      {
        path: '/case/general/:patientId?/:step?',
        name: 'case.general',
        props: true,
        meta: {title: '全科病历采集', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.general', permission: 'case.general'},
        component:    () => import('../views/generalCase')
      },
      {
        path: '/case/reinput/:reInputPatientId',
        name: 'case.reinput',
        props: true,
        meta: {title: '全科病历复诊', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.general', permission: 'case.general'},
        component:    () => import('../views/generalCase')
      },
      {
        path: '/case/inquire',
        name: 'case.inquire',
        meta: {title: '病历查询', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.inquire', permission: 'case.inquire'},
        component: () => import('../views/MedicalMgr')
      },
      {
        path: '/case/patientInquirie',
        name: 'case.patientInquirie',
        meta: {title: '患者查询', icon: '', requireAuth: true, menu: 'case', subMenu: 'case.patientInquirie', permission: 'case.patientInquirie'},
        component: () => import('../views/patientInquirie')
      },
      {
        path: '/case/update/:patientId',
        props: true,
        component: () => import('../views/Diagnosis.vue'),
        name: 'case.diagnose',
        meta: {description: '病历诊断',requiresAuth: true,menu: 'case',subMenu: 'case.general',permission: 'case.general'}
      },
      {
        path: '/case/calibration/:patientId',
        component: () => import('../views/Calibration.vue'),
        name: 'case.calibration',
        props:true,
        meta: {description: '病历批注',requiresAuth: true,menu: 'case',subMenu: 'case.general',permission: 'case.general'}
      },
      {
        path: 'case/details/:patientId',
        component: () => import('../views/MedicalResult.vue'),
        name: 'case.result',
        props: true,
        meta: {description: '病历查看',requiresAuth: true,menu: 'case',subMenu: 'case.inquire',permission: 'case.general'}
      },
      {
        path: '/education',
        redirect: 'education/consultation',
      },
      {
        path: '/education/consultation',
        name: 'education.consultation',
        meta: {title: '师生交流', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.consultation',permission: 'education.consultation'},
        component: () => import('../views/ConsultationMgr')
      },
      {
        path: '/education/typical-medcase',
        name: 'education.typical_medcase',
        meta: {title: '典型病历库', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.typical_medcase',permission: 'education.typical_medcase'},
        component: () => import('../views/typicalMedcase/index')
      },
      {
        path: '/education/random-mock-diagnose',
        name: 'education.random_mock_diagnose',
        meta: {title: '随机模拟开方', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.random_mock_diagnose',permission: 'education.random_mock_diagnose'},
        component: () => import('../views/mockDiagnose/random')
      },
      {
        path: '/education/mock-diagnose',
        name: 'education.mock_diagnose',
        meta: {title: '模拟开方记录', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.mock_diagnose',permission: 'education.mock_diagnose'},
        component: () => import('../views/mockDiagnose')
      },
      {
        path: '/education/teachers_notes',
        name: 'education.teachers_notes',
        meta: {title: '跟师笔记', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.teachers_notes',permission: 'education.teachers_notes'},
        component: () => import('../views/teachernotes')
      },
      {
        path: '/education/learning_experience',
        name: 'education.learning_experience',
        meta: {title: '学习心得', icon: '',requireAuth: true,menu: 'education',subMenu: 'education.learning_experience',permission: 'education.learning_experience'},
        component: () => import('../views/learningExperience')
      },
      {
        path: '/achievement',
        redirect: 'achievement/manage',
      },
      {
        path: '/achievement/medical_cases',
        name: 'achievement.medical_cases',
        meta: {title: '医案库', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.medical_cases',permission: 'achievement.medical_cases'},
        component: () => import('../views/medicalRecord')
      },
      {
        path: '/achievement/diagnosis_treatment',
        name: 'achievement.diagnosis_treatment',
        meta: {title: '诊疗方案', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.diagnosis_treatment',permission: 'achievement.diagnosis_treatment'},
        component: () => import('../views/TreatmentPlan.vue')
      },
      {
        path: '/achievement/paper',
        name: 'achievement.paper',
        meta: {title: '论文', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.paper',permission: 'achievement.paper'},
        component: () => import('../views/paper')
      },
      {
        path: '/achievement/treatise',
        name: 'achievement.treatise',
        meta: {title: '论著', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.treatise',permission: 'achievement.treatise'},
        component: () => import('../views/lunzhu')
      },
      {
        path: '/achievement/research_report',
        name: 'achievement.research_report',
        meta: {title: '研究报告', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.research_report',permission: 'achievement.research_report'},
        component: () => import('../views/yanjiu')
      },
      {
        path: '/achievement/patent',
        name: 'achievement.patent',
        meta: {title: '知识产权', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.patent',permission: 'achievement.patent'},
        component: () => import('../views/patentCenter')
      },
      {
        path: '/achievement/preparation',
        name: 'achievement.preparation',
        meta: {title: '院内制剂', icon: '', requireAuth: true, menu: 'achievement', subMenu: 'achievement.preparation', permission: 'achievement.preparation'},
        component: () => import('../views/preparationMgr')
      },
      {
        path: '/achievement/newdrug_certificate',
        name: 'achievement.newdrug_certificate',
        meta: {title: '新药证书', icon: '', requireAuth: true, menu: 'achievement', subMenu: 'achievement.newdrug_certificate', permission: 'achievement.newdrug_certificate'},
        component: () => import('../views/xinyao')
      },
      {
        path: '/achievement/continuing_education',
        name: 'achievement.continuing_education',
        meta: {title: '继续教育项目', icon: '', requireAuth: true, menu: 'achievement', subMenu: 'achievement.continuing_education', permission: 'achievement.continuing_education'},
        component: () => import('../views/jixu')
      },
      {
        path: '/achievement/video',
        name: 'achievement.video',
        meta: {title: '视频管理', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.video',permission: 'achievement.video'},
        component: () => import('../views/LearningCenter')
      },
      {
        path: '/achievement/video_maintenance',
        name: 'achievement.video_maintenance',
        meta: {title: '视频维护', icon: '',requireAuth: true,menu: 'achievement',subMenu: 'achievement.video_maintenance',permission: 'achievement.video_maintenance'},
        component: () => import('../views/ResourceManagement')
      },
      {
        path: '/achievement/readingExperience',
        name: 'achievement.readingExperience',
        meta: {title: '读书心得', icon: '', requireAuth: true,  menu: 'achievement', subMenu: 'achievement.readingExperience', permission: 'achievement.readingExperience'},
        component: () => import('../views/readingExperience')
      },
      {
        path: '/achievement/experience',
        name: 'achievement.experience',
        meta: {title: '经验', icon: '', requireAuth: true,  menu: 'achievement', subMenu: 'achievement.experience', permission: 'achievement.experience'},
        component: () => import('../views/experience')
      },
      {
        path: '/achievement/award',
        name: 'achievement.award',
        meta: {title: '获奖', icon: '', requireAuth: true,  menu: 'achievement', subMenu: 'achievement.award', permission: 'achievement.award'},
        component: () => import('../views/award')
      },
      {
        path: '/achievement/medicalNotes',
        name: 'achievement.medicalNotes',
        meta: {title: '医话', icon: '', requireAuth: true,  menu: 'achievement', subMenu: 'achievement.medicalNotes', permission: 'achievement.medicalNotes'},
        component: () => import('../views/medicalNotes')
      },
      {
        path: '/kyfx',
        redirect: '/kyfx/analysisPool',
      },
      {
        path: '/kyfx/analysisPool',
        name: 'kyfx.analysisPool',
        meta: {title: '分析池', icon: '',requireAuth: true,menu: 'kyfx',subMenu: 'kyfx.analysisPool',permission: 'kyfx.analysisPool'},
        component: () => import('../views/analysisPool')
      },
      {
        path: '/kyfx/dataMining',
        name: 'kyfx.dataMining',
        meta: {title: '数据挖掘', icon: '',requireAuth: true,menu: 'kyfx',subMenu: 'kyfx.dataMining',permission: 'kyfx.dataMining'},
        component: () => import('../views/DataMine')
      },
      {
        path: '/kyfx/analysisReport',
        name: 'kyfx.analysisReport',
        meta: {title: '分析报告', icon: '',requireAuth: true,menu: 'kyfx',subMenu: 'kyfx.analysisReport',permission: 'kyfx.analysisReport'},
        component: () => import('../views/analysisReport')
      },
      {
        path: '/sys',
        redirect: 'sys/studio',
      },
      {
        path: '/sys/versionManage',
        name: 'sys.versionManage',
        meta: {title: '版本管理', icon: '',requireAuth: true,menu: 'sys',subMenu: 'sys.versionManage',permission: 'sys.versionManage'},
        component: () => import('../views/versionManage')
      },
      {
        path: '/sys/studio',
        name: 'sys.studio',
        meta: {title: '工作室管理', icon: '',requireAuth: true,menu: 'sys',subMenu: 'sys.studio',permission: 'sys.studio'},
        component: () => import('../views/SysStudioMgr')
      },
      {
        path: '/sys/role',
        name: 'sys.role',
        meta: {title: '工作室管理', icon: '', requireAuth: true, menu: 'sys', subMenu: 'sys.role', permission: 'sys.role'},
        component: () => import('../views/RoleMgr')
      },
      {
        path: '/sys/user',
        name: 'sys.user',
        meta: {title: '工作室管理', icon: '', requireAuth: true, menu: 'sys', subMenu: 'sys.user', permission: 'sys.user'},
        component: () => import('../views/UserMgr')
      },
      {
        path: '/studio/',
        redirect: 'studio/mgr'
      },
      {
        path: '/studio/mgr',
        name: 'studio.mgr',
        meta: {title: '工作室维护', icon: '', requireAuth: true, menu: 'studio', subMenu: 'studio.mgr', permission: 'studio.mgr'},
        component: () => import('../views/StudioMgr')
      },
      {
        path: '/studio/user',
        name: 'studio.user',
        meta: {title: '用户管理', icon: '', requireAuth: true,  menu: 'studio', subMenu: 'studio.user', permission: 'studio.user'},
        component: () => import('../views/UserMgr')
      },
      {
        path: '/studio/studentEvaluation',
        name: 'studio.studentEvaluation',
        meta: {title: '学员评价', icon: '', requireAuth: true,  menu: 'studio', subMenu: 'studio.studentEvaluation', permission: 'studio.studentEvaluation'},
        component: () => import('../views/studentEvaluation')
      },
      {
        path: '/studio/activity',
        name: 'studio.activity',
        meta: {title: '活动管理', icon: '', requireAuth: true,  menu: 'studio', subMenu: 'studio.activity', permission: 'studio.activity'},
        component: () => import('../views/activityManagement')
      },
      {
        path: '/studio/teacherManagement',
        name: 'studio.teacherManagement',
        meta: {title: '跟师管理', icon: '', requireAuth: true,  menu: 'studio', subMenu: 'studio.teacherManagement', permission: 'studio.teacherManagement'},
        component: () => import('../views/teacherManagement')
      },
      {
        path: '/studio/annualPlan',
        name: 'studio.annualPlan',
        meta: {title: '年度计划', icon: '', requireAuth: true,  menu: 'studio', subMenu: 'studio.annualPlan', permission: 'studio.annualPlan'},
        component: () => import('../views/annualPlan')
      },
      {
        path: '/kwg/',
        redirect: 'kwg/disease'
      },
      {
        path: '/kwg/disease',
        name: 'kwg.disease',
        meta: {title: '疾病管理', icon: '', requireAuth: true,  menu: 'kwg', subMenu: 'kwg.disease', permission: 'kwg.disease'},
        component: () => import('../views/DiseaseMgr')
      },
      {
        path: '/kwg/syndrome',
        name: 'kwg.syndrome',
        meta: {title: '证型管理', icon: '', requireAuth: true,  menu: 'kwg', subMenu: 'kwg.syndrome', permission: 'kwg.syndrome'},
        component: () => import('../views/SyndromeMgr')
      },
      {
        path: '/kwg/symptom',
        name: 'kwg.symptom',
        meta: {title: '症状管理', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.symptom', permission: 'kwg.symptom'},
        component: () => import('../views/SymptomMgr')
      },

      {
        path: '/kwg/zhongcheng',
        name: 'kwg.zhongcheng',
        meta: {title: '中成药', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.zhongcheng', permission: 'kwg.zhongcheng'},
        component: () => import('../views/zhongchengMgr')
      },
      {
        path: '/kwg/westernMedicine',
        name: 'kwg.westernMedicine',
        meta: {title: '西药', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.westernMedicine', permission: 'kwg.westernMedicine'},
        component: () => import('../views/westernMedicineMgr')
      },
      {
        path: '/kwg/agreementParty',
        name: 'kwg.agreementParty',
        meta: {title: '协定方', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.agreementParty', permission: 'kwg.agreementParty'},
        component: () => import('../views/agreementPartyMgr')
      },
      {
        path: '/kwg/foodProducts',
        name: 'kwg.foodProducts',
        meta: {title: '食养商品', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.foodProducts', permission: 'kwg.foodProducts'},
        component: () => import('../views/foodProductsMgr')
      },
      {
        path: '/kwg/entrustTemplate',
        name: 'kwg.entrustTemplate',
        meta: {title: '嘱托模板', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.entrustTemplate', permission: 'kwg.entrustTemplate'},
        component: () => import('../views/entrustTemplateMgr')
      },
      {
        path: '/kwg/suitableSkill',
        name: 'kwg.suitableSkill',
        meta: {title: '适宜技术', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.suitableSkill', permission: 'kwg.suitableSkill'},
        component: () => import('../views/suitableSkillMgr')
      },
      {
        path: '/kwg/suitableSkillPart',
        name: 'kwg.suitableSkillPart',
        meta: {title: '适宜技术部位', icon: '', requireAuth: true, menu: 'kwg', subMenu: 'kwg.suitableSkillPart', permission: 'kwg.suitableSkillPart'},
        component: () => import('../views/suitableSkillPartMgr')
      }
    ]
  },
  {
    path: '/403',
    name: 'forbidden',
    component: () => import('../views/NoPermission')
  },
  {
    path: '/pre/wenjuan',
    name: 'pre.wenjuan',
    meta: {title: "预研问卷单", requireAuth: false},
    component: () => import("../views/PreWenJuan")
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test1')
  },
  {
    path: '/ai/lab',
    name: 'ai.lab',
    meta: {title: "AI实验室", requireAuth: true},
    component: () => import('../views/AiLab.vue')
  },
  {
    path: '/ai',
    name: "ai.layout",
    redirect: '/ai/',
    component: () => import('../components/layout/AiDemoLayout'),
    children: [
      {
        path: '/ai/input',
        name: 'ai.ai',
        meta: {title: "模型训练", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/Ai')
      },
      {
        path: '/ai/demo/step2',
        name: 'ai.demo.step2',
        meta: {title: "模型评估", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/AiStep2')
      },
      {
        path: '/ai/demo/step3',
        name: 'ai.demo.step3',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/AiStep3')
      },
      {
        path: '/ai/demo/step4',
        name: 'ai.demo.step4',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/AiStep4')
      },
      {
        path: '/ai/demo/step5',
        name: 'ai.demo.step5',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/AiStep5')
      },
      {
        path: '/ai/medcase',
        name: 'ai.medcase',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/ChoiceMedcase')
      },
      {
        path: '/ai/result',
        name: 'ai.result',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/ResultStep1')
      },
      {
        path: '/ai/lab',
        name: 'ai.lab',
        meta: {title: "AI实验室", requireAuth: true, permission: 'ai'},
        component: () => import('../views/aiDemo/ResultStep2')
      },
      {
        path: '/ai/demo/result/step2',
        name: 'ai.demo.result/step2',
        meta: {title: "模型预测结果", requireAuth: false, permission: 'ai'},
        component: () => import('../views/aiDemo/ResultStep2')
      },
    ]
  },
  {
    path: '/medical/print/:patientId',
    props: true,
    name: 'medicalPrint',
    component: () => import('../views/PrintMedical')
  },
  {
    path: '/medical/zhuanbingPrint/:patientId',
    props: true,
    name: 'zhuanbingMedicalPrint',
    component: () => import('../views/zhuanbingPrintMedical')
  },
  {
    path: '*',
    component: () => import('../views/NotFound')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
